import DraftPostsPartial from "../../partials/campaign/draft-posts.partial";

export default function DraftPostsScreen() {
  return <DraftPostsPartial />;
}
